import { Content, Page } from '@backstage/core-components';
import { Grid, makeStyles } from '@material-ui/core';
import { SearchContextProvider } from '@backstage/plugin-search-react';
import { HomePageSearchBar } from '@backstage/plugin-search';
import {
  HomePageToolkit,
  HomePageCompanyLogo,
  HomePageStarredEntities,
  TemplateBackstageLogoIcon,
} from '@backstage/plugin-home';
import LogoFull from '../Root/LogoFull';
import GithubIcon from '@material-ui/icons/GitHub';
import GroupIcon from '@material-ui/icons/People';
import CategoryIcon from '@material-ui/icons/Category';
import LibraryBooks from '@material-ui/icons/LibraryBooks';

// Styles
const useStyles = makeStyles(theme => ({
  searchBarInput: {
    maxWidth: '60vw',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '50px',
    boxShadow: theme.shadows[1],
  },
  searchBarOutline: {
    borderStyle: 'none',
  },
}));

const useLogoStyles = makeStyles(theme => ({
  container: {
    margin: theme.spacing(5, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  logoImg: {
    width: 'auto',
    height: 90, // tamaño mayor
    maxWidth: '90vw',
  },
}));

export const HomePage = () => {
  const classes = useStyles();
  const logoClasses = useLogoStyles();

  // Direct links to useful locations, which you can change to whatever you want
  const tools = [
    {
      url: '/create/actions',
      label: 'Create/Actions',
      icon: <TemplateBackstageLogoIcon />,
    },
    {
      url: '/docs',
      label: 'Docs',
      icon: <LibraryBooks />,
    },
    {
      url: '/catalog?filters%5Bkind%5D=user',
      label: 'User Catalog',
      icon: <CategoryIcon />,
    },
    {
      url: '/catalog?filters%5Bkind%5D=group',
      label: 'Group Catalog',
      icon: <GroupIcon />,
    },
    {
      url: 'https://github.com/profileit/community',
      label: 'Profile Community',
      icon: <GithubIcon />,
    },
  ];

  // Use the search bar and starred entities as is
  return (
    <SearchContextProvider>
      <Page themeId="home">
        <Content>
          <Grid container justifyContent="center" spacing={6}>
            <HomePageCompanyLogo
              className={logoClasses.container}
              logo={<LogoFull className={logoClasses.logoImg} />}
            />
            <Grid container item xs={12} justifyContent="center">
              <HomePageSearchBar
                InputProps={{
                  classes: {
                    root: classes.searchBarInput,
                    notchedOutline: classes.searchBarOutline,
                  },
                }}
                placeholder="Search"
              />
            </Grid>
            <Grid
              item
              xs={12}
              style={{ textAlign: 'center', margin: '32px 0 16px 0' }}
            >
              <h2 style={{ fontWeight: 700, margin: 0 }}>
                ¡Bienvenido al Developer Portal de Profile!
              </h2>
              <p style={{ fontSize: 18, color: '#666', marginTop: 8 }}>
                Centraliza la gestión, documentación y automatización de tus
                proyectos.
              </p>
            </Grid>
            <Grid container item xs={12}>
              <Grid item xs={12} md={6}>
                <HomePageStarredEntities />
              </Grid>
              <Grid item xs={12} md={6}>
                <HomePageToolkit tools={tools} />
              </Grid>
            </Grid>
          </Grid>
        </Content>
      </Page>
    </SearchContextProvider>
  );
};
